import { sentryOnError } from '@sentry/react-router';
import { startTransition, StrictMode } from 'react';
import { hydrateRoot } from 'react-dom/client';
import { HydratedRouter } from 'react-router/dom';

import { profilerInit } from '~/lib/profiler';
import { sentryInit } from '~/lib/sentry';
import { store } from '~/store/store';

/**
 * Client entry point. Boot order matters: features must load before Sentry init
 * reads the runtime DSN.
 */
async function main() {
    await store.getActions().features.loadFeatures();
    profilerInit();
    sentryInit();

    startTransition(() => {
        hydrateRoot(
            document,
            <StrictMode>
                <HydratedRouter onError={sentryOnError} />
            </StrictMode>,
        );
    });
}

void main();
